module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Home/Flower#2-9cc3c2be5b043f47de4901fda479b3bc.svg";